export type SelectOption = {
  label: string;
  value: string;
};

export type BinderFormState = {
  binderName: string;
  crmProducts: SelectOption[] | null;
  crmDetailGroup: SelectOption | null;
  businessUnits: SelectOption[] | null;
  isValid: boolean;
};

export enum BinderFormActionType {
  SET_BINDER_NAME = 'SET_BINDER_NAME',
  SET_CRM_PRODUCTS = 'SET_CRM_PRODUCTS',
  SET_CRM_DETAIL_GROUP = 'SET_CRM_DETAIL_GROUP',
  SET_BUSINESS_UNITS = 'SET_BUSINESS_UNITS',
  RESET_FORM = 'RESET_FORM',
}

export type BinderFormSelectType = BinderFormActionType.SET_CRM_PRODUCTS
| BinderFormActionType.SET_CRM_DETAIL_GROUP
| BinderFormActionType.SET_BUSINESS_UNITS;

export type BinderFormAction =
  | { type: BinderFormActionType.SET_BINDER_NAME; payload: string }
  | { type: BinderFormActionType.SET_CRM_PRODUCTS; payload: SelectOption[] | null }
  | { type: BinderFormActionType.SET_CRM_DETAIL_GROUP; payload: SelectOption | null }
  | { type: BinderFormActionType.SET_BUSINESS_UNITS; payload: SelectOption[] | null }
  | { type: BinderFormActionType.RESET_FORM };

export const initialBinderFormState: BinderFormState = {
  binderName: '',
  crmProducts: null,
  crmDetailGroup: null,
  businessUnits: null,
  isValid: false,
};

export const MAX_NAME_LENGTH = 100;
export const MAX_LINE_LENGTH = MAX_NAME_LENGTH / 2;

export const binderFormReducer = (
  state: BinderFormState,
  action: BinderFormAction,
): BinderFormState => {
  let newState: BinderFormState;

  switch (action.type) {
    case BinderFormActionType.SET_BINDER_NAME: {
      const newName = action.payload;
      if (newName.length <= MAX_NAME_LENGTH) {
        newState = { ...state, binderName: newName };
      } else {
        return state;
      }
      break;
    }
    case BinderFormActionType.SET_CRM_PRODUCTS:
      newState = { ...state, crmProducts: action.payload };
      break;
    case BinderFormActionType.SET_CRM_DETAIL_GROUP:
      newState = { ...state, crmDetailGroup: action.payload };
      break;
    case BinderFormActionType.SET_BUSINESS_UNITS:
      newState = { ...state, businessUnits: action.payload };
      break;
    case BinderFormActionType.RESET_FORM:
      return initialBinderFormState;
    default:
      return state;
  }

  newState.isValid = Boolean(
    newState.binderName &&
    newState.crmProducts &&
    newState.crmProducts.length > 0,
  );

  return newState;
};
